import React from 'react';
import { useIntl } from 'react-intl';

import { FavoritesFilterButtonContainer, FilledStarIcon, OutlineStarIcon } from './styles';

export interface FavoritesFilterButtonProps {
  isActive: boolean;
  onClick: VoidFunction;
}

/**
 * The list toolbar's "favorites only" toggle — filters the resource list down to the current user's
 * favorited resources (`favorites_only=true` on `GET .../resources`). Styled like `FilterIcon` but
 * with its own amber active state rather than the generic filter dot, so it reads as a favorites
 * control rather than another applied filter.
 */
export const FavoritesFilterButton = ({ isActive, onClick }: FavoritesFilterButtonProps): JSX.Element => {
  const intl = useIntl();

  return (
    <FavoritesFilterButtonContainer
      type="button"
      isActive={isActive}
      onClick={onClick}
      aria-label={intl.formatMessage({ id: 'favorites_only' })}
      aria-pressed={isActive}
      data-testid="favorites-filter-button"
    >
      {isActive ? (
        <FilledStarIcon data-testid="favorites-filter-star-filled" />
      ) : (
        <OutlineStarIcon data-testid="favorites-filter-star-outline" />
      )}
    </FavoritesFilterButtonContainer>
  );
};
